// import MaskedInput from 'react-text-mask'
// import { makeTelMask, isDateValid } from './common'
// import { history } from './history'

import { useState } from 'react'

import CPFInput from "./CPFInput"
import MandatoryField from "./MandatoryField"
import MaskedInput from 'react-text-mask'
import { makeTelMask } from './common'

const canSubmit = (data) => {
  // console.log('Checking can submit', data)
  let result = 
    data.bancoTipo === 'pix' ? (
      !!data.bancoPix && data.bancoPix.trim() !== '' &&
      !!data.bancoTipoPix && data.bancoTipoPix !== '-'
    ) : (
      !!data.bancoBanco && data.bancoBanco.trim() !== '' &&
      !!data.bancoAgencia && data.bancoAgencia.trim() !== '' &&
      !!data.bancoConta && data.bancoConta.trim() !== '' &&
      !!data.bancoTitular && data.bancoTitular.trim() !== '' &&
      !!data.bancoCPF && data.bancoCPF.trim() !== '' &&
      data.bancoTipoConta !== '-'
    )
  return result
}


const FormPage5 = (props) => {
const data = props.formData
const [valid, setValid] = useState(false)

// console.log('Form page 2 here', props)

setTimeout(() => setValid(canSubmit(data), 1))

  return (

<>
<form className="form"
  style={{
  alignItems: 'center'
}}>

<div className="form-header">Dados bancários</div>

<div className="form-field-group">
  <MandatoryField title='Tipo:' />
  <select name="bancoTipo" className="form-text"
    value={data.bancoTipo ? data.bancoTipo : 'pix'}
    onChange={((e) => {
      // let formData = {
      //   ...data,
      //   bancoTipo: e.target.value
      // }
      props.setForm({bancoTipo: e.target.value})
      setValid(canSubmit({...data, bancoTipo: e.target.value}))

    })}>
    <option value="pix">Pix</option>
    <option value="agencia">Agência e conta</option>
  </select>
</div>

    {data.bancoTipo === 'pix' ? (
      <div className="form-sub-group">
        <div className="form-field-group">
        <MandatoryField title='Tipo de chave Pix:' />
        <select name="bancoTipoPix" className="form-text"
          value={data.bancoTipoPix ? data.bancoTipoPix : '-'}
          onChange={((e) => {
            props.setForm({bancoTipoPix: e.target.value, bancoPix: null})
            setValid(canSubmit({...data, bancoTipoPix: e.target.value}))
          })}
          >
            <option value='-'></option>
            <option value='telefone'>Telefone</option>
            <option value='cpf'>CPF</option>
            <option value='email'>E-mail</option>
            <option value='aleatória'>Chave aleatória</option>
          </select>
        </div>

        <div className="form-field-group">
          {data.bancoTipoPix !== '-' && 
          <MandatoryField title='Chave Pix:' />
          }

          {data.bancoTipoPix === 'cpf' && (
            <CPFInput name="pixcpf" className="form-text" placeholder='___.___.___-__'
            value={data.bancoPix ? data.bancoPix : ''}
            onChange={(cpf, raw, valid) => {
              props.setForm({bancoPix: cpf})
              setValid(canSubmit({...data, bancoPix: cpf}))
            }}
          />
          
          )}

          {data.bancoTipoPix === 'telefone' && (
  <MaskedInput
  // disabled={this.state.loading}
  value={!!data.bancoPix ? data.bancoPix : ''}
  placeholder={'(__) _____-____'}
  // placeholderChar={' '}
  // guide={false}
  mask = {
    makeTelMask(!!data.tel ? data.tel : '')
  }
  onChange={((e) => {
    let value = e.target.value
    if (!value) { value = ''}
    if(value === '(__) _____-____') {
      value = ''
    } else {
      value = value.replace(/[_]/g, '')
    }
    props.setForm({bancoPix: value})
    setValid(canSubmit({...data, bancoPix: value}))
    })}
    className="form-text"
    />         
          
    )}

        {data.bancoTipoPix === 'email' && (
        <input type="email" name="titular" className="form-text"
          value={data.bancoPix ? data.bancoPix : ''}
          onChange={((e) => {
            props.setForm({bancoPix: e.target.value})
            setValid(canSubmit({...data, bancoPix: e.target.value}))
          })}
        />
        )}

          {data.bancoTipoPix === 'aleatória' && (
          <input type="text" name="titular" className="form-text"
            value={data.bancoPix ? data.bancoPix : ''}
            onChange={((e) => {
              props.setForm({bancoPix: e.target.value})
              setValid(canSubmit({...data, bancoPix: e.target.value}))
            })}
          />
          )}
        </div>

      </div>
    ) : (
      <div className="form-sub-group">
        <div className="form-field-group">
        <MandatoryField title='Banco:' />
          <input type="text" name="banco" className="form-text"
            value={data.bancoBanco ? data.bancoBanco : ''}
            onChange={((e) => {
              // let formData = {
              //   ...data,
              //   banco: e.target.value
              // }
              // this.setState({formData})
              props.setForm({bancoBanco: e.target.value})
              setValid(canSubmit({...data, bancoBanco: e.target.value}))
            })}
          />
        </div>
        <div className="form-field-group">
        <MandatoryField title='Agência:' />
          <input type="text" name="agencia" className="form-text"
            value={data.bancoAgencia ? data.bancoAgencia : ''}
            onChange={((e) => {
              // let formData = {
              //   ...data,
              //   bancoAgencia: e.target.value
              // }
              // this.setState({formData})
              props.setForm({bancoAgencia: e.target.value})
              setValid(canSubmit({...data, bancoAgencia: e.target.value}))

            })}
          />
        </div>
        <div className="form-field-group">
        <MandatoryField title='Conta:' />
          <input type="text" name="conta" className="form-text"
            value={data.bancoConta ? data.bancoConta : ''}
            onChange={((e) => {
              // let formData = {
              //   ...data,
              //   bancoConta: e.target.value
              // }
              // this.setState({formData})
              props.setForm({bancoConta: e.target.value})
              setValid(canSubmit({...data, bancoConta: e.target.value}))

            })}
          />
        </div>
        <div className="form-field-group">
        <MandatoryField title='Tipo de conta:' />
          <select name="bancoTipoConta" className="form-text"
            value={data.bancoTipoConta ? data.bancoTipoConta : 'corrente'}
            onChange={((e) => {
              // let formData = {
              //   ...data,
              //   bancoTipoConta: e.target.value
              // }
              props.setForm({bancoTipoConta: e.target.value})
              setValid(canSubmit({...data, bancoTipoConta: e.target.value}))

            })}>
            <option value="-"></option>
            <option value="corrente">Conta corrente</option>
            <option value="poupanca">Poupança</option>
          </select>
        </div>
        <div className="form-field-group">
        <MandatoryField title='Nome do titular:' />
          <input type="text" name="titular" className="form-text"
            value={data.bancoTitular ? data.bancoTitular : ''}
            onChange={((e) => {
              // let formData = {
              //   ...data,
              //   bancoTitular: e.target.value
              // }
              // this.setState({formData})
              props.setForm({bancoTitular: e.target.value})
              setValid(canSubmit({...data, bancoTitular: e.target.value}))

            })}
          />
        </div>
        <div className="form-field-group">
        <MandatoryField title='CPF do titular:' />
          <CPFInput name="cpftitular" className="form-text" placeholder='___.___.___-__'
            value={data.bancoCPF ? data.bancoCPF : data.cpf}
            onChange={(cpf, raw, valid) => {
              // let formData = {
              //   ...data,
              //   bancoCPF: cpf,
              // }
              props.setForm({bancoCPF: cpf})
              setValid(canSubmit({...data, bancoCPF: cpf}))

            }}
              // this.setState({formData})
          />
        </div>

      </div> 
    )}


<div className="form-send-row">
<button
  // onClick={() => history.goBack()}
  // disabled={!this.state.cpf || !this.state.isCPFValid || this.state.loading}
  className="login-button"
  onClick={() => props.onPrev()}
>{`${'< Voltar'}`}
</button>
<button
  // disabled={!this.state.cpf || !this.state.isCPFValid || this.state.loading}
  disabled={!valid}
  className="login-button"
  onClick={() => props.onNext()}
>{`${'Concluir >'}`}</button>
</div>
{/* {
!!this.state.error &&
<div className="login-error">{this.state.error}</div>
} */}
</form>
</>
)
}

export default FormPage5
